import React from 'react';
import { SvgProps, Svg } from '../../Svg';

const Icon: React.FC<SvgProps> = () => {
  return (
    <Svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.999 3C8.69159 3 6 5.69614 6 9.01035C6 10.6931 6.80148 12.032 7.44537 13.1073C7.83403 13.7564 8.20045 14.3696 8.20045 14.7707V17.0028V18.5897C8.20045 19.045 8.5688 19.4141 9.0232 19.4141H9.91846V20.1756C9.91846 20.6309 10.2868 21 10.7412 21H13.2588C13.7132 21 14.0815 20.6309 14.0815 20.1756V19.4141H14.9768C15.4312 19.4141 15.7995 19.045 15.7995 18.5897V17.0154C15.7995 17.0106 15.8025 17.0057 15.8025 17.0009C15.8025 16.9011 15.7783 16.8032 15.7406 16.7102C15.7135 16.6405 15.671 16.5804 15.6275 16.5223C15.6033 16.4894 15.5878 16.4496 15.5608 16.4206C15.5453 16.4051 15.524 16.4002 15.5076 16.3867C15.3635 16.2617 15.1818 16.1793 14.9768 16.1793H9.84595V14.7717C9.84595 13.9143 9.36449 13.1112 8.85691 12.2616C8.26136 11.2666 7.64647 10.2378 7.64647 9.01129C7.64647 6.6058 9.60039 4.64887 12.001 4.64887C14.4015 4.64887 16.3545 6.6058 16.3545 9.01129C16.3545 9.27287 16.3274 9.52766 16.2723 9.79213C16.1785 10.2378 16.4628 10.6747 16.9065 10.7687C17.3522 10.8694 17.7873 10.5798 17.8811 10.1332C17.9594 9.76018 18 9.38428 18 9.01227C17.9971 5.69709 15.3055 3 11.999 3Z"
        fill="#A3A3A3"
      />
    </Svg>
  );
};

export default Icon;
